export class CalcFondResponseModel {
  public ps: number;
  public bruttoPraemieZw: number;
  public nettoPraemie1Jhrl: number;
  public auszahlungsbetragOwn: number;
  public auszahlungsbetragLow: number;
  public auszahlungsbetragMid: number;
  public auszahlungsbetragHigh: number;

  public vagSparPraemiePerc: number;
  public vagPraemieAblebenPerc: number;
  public vagPraemieErkrankungPerc: number;
  public vagAbschlussUVertriebsKostenPerc: number;
  public vagVerwaltungsKostenPerc: number;
  public vagVersSteuerPerc: number;
  public vagNachlassZuschlagPerc: number;
  public vagEffGesamtVerzinsungOwn: number;

  public vagEffGesamtVerzinsungLow: number;
  public vagEffGesamtVerzinsungMid: number;
  public vagEffGesamtVerzinsungHigh: number;

  public hiOs: number;
  public hiPremija: number;

  public oSr1: number;
  public oSr1UTZ: number;
  public premijaR1: number;

  public performanceOwn: number;
  public performanceLow: number;
  public performanceMid: number;
  public performanceHigh: number;


  public netoPremija: number;
  public brutoPremija: number;
  public rata: number;
  public prvaRata: number;


  public ui: number;
  public uiOs: number;
  public uiBolDan: number;
  public uiPremija: number;


  public unitLinkedPremija: number;
  public utzPremija: number;
  public utzOS: number;

  public memo: string;


}



// WEBPACK FOOTER //
// ./src/app/models/calcfond-response.model.ts